const actions = {
  INITIALIZE({ commit }, { agency }) {
    commit('INITIALIZE', { agency })
  },
}

export default actions
